
// User has opted out of tracking. MUST be kept in sync with the code that disables the segment script in the public html file in BOTH repos.
export const TrackingOptOutCookie = 'at-tracking-opted-out';
